import { render, staticRenderFns } from "./childrenages.vue?vue&type=template&id=62c64d9a&"
import script from "./childrenages.vue?vue&type=script&lang=js&"
export * from "./childrenages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62c64d9a')) {
      api.createRecord('62c64d9a', component.options)
    } else {
      api.reload('62c64d9a', component.options)
    }
    module.hot.accept("./childrenages.vue?vue&type=template&id=62c64d9a&", function () {
      api.rerender('62c64d9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZiPvTylgyOuM/JS/childrenages.vue"
export default component.exports